export default {
  locations(state, value) {
    return (state.locations = value);
  },
  totalLocations(state, value) {
    return (state.totalLocations = value);
  },
  tableLoading(state, value) {
    return (state.tableLoading = value);
  },
  perPageForLocations(state, value) {
    return (state.perPageForLocations = value);
  },
  currentPageForLocations(state, value) {
    return (state.currentPageForLocations = value);
  },
  logs(state, value) {
    return (state.logs = value);
  },
  totalLogs(state, value) {
    return (state.totalLogs = value);
  },
  perPageForLogs(state, value) {
    return (state.perPageForLogs = value);
  },
  currentPageForLogs(state, value) {
    return (state.currentPageForLogs = value);
  },
  searchQuery(state, value) {
    return (state.searchQuery = value);
  },
  filterDate(state, value) {
    return (state.filterDate = value);
  },
  filterStatus(state, value) {
    return (state.filterStatus = value);
  },
};
